import React, { useEffect, useState } from "react";
import Goals from "./Goals";
import GameStart from "../../utils/GameStart";
import { DndProvider } from "react-dnd";
import { TouchBackend } from "react-dnd-touch-backend";
import Card from "react-bootstrap/Card";
import BackToGameList from "../../utils/BackToGameList";
import { HTML5Backend } from 'react-dnd-html5-backend'
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";

function CategorySorts(props) {
  
  const [triggerTimer, setTriggerTimer] = useState();
  const [time, setTime] = useState(0);
  const [resetGame, setResetGame] = useState(0);
  const [timesPlayed, setTimesPlayed] = useState(0);
  const [openGameStartModal, setOpenGameStartModal] = useState();
  const [dndEngine, setDNDEngine] = useState();
  const [dndEngineReady, setDNDEngineReady] = useState(false);
  const [gameSelect, setGameSelect] = useState([]);
  const [goalData, setGoalData] = useState([]);
  const [groupID, setGroupID] = useState();
  const [selectedGame, setSelectedGame] = useState();

  useEffect(() => {
    getGameList()
  },[])

  const  getGameList = async () =>{
    const res = await makeGetRequest(urls.categorySortsGameList,'',true)
    setGroupID()
    setGameSelect(res.data)
  }

  useEffect(() => {
    wordData()
  },[selectedGame])

  const wordData = async () => {
    if(selectedGame != undefined){
      const response = await makeGetRequest(
        urls.category_sorts + "?active=True&id=" + selectedGame,
        "",
        true
      );
      setGoalData(response.data);
    }else{
      const response = await makeGetRequest(
        urls.category_sorts + "?active=True",
        "",
        true
      );
      const overArcingGroups = response.data.map((item) => item.category_sorts);
      const count = Math.floor(Math.random() * overArcingGroups.length);
      const groupID = overArcingGroups[count];
      setGroupID(groupID);
      setGoalData(response.data.filter((goals) => {
        return goals.category_sorts === groupID;
      }));
    }
  };

  useEffect(() => {
    if(goalData.length > 1){
      setEngine()
    }
  },[goalData])

  const setEngine = () => {
    if(('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0)){
      setDNDEngine((<DndProvider backend={TouchBackend}>
                    <Card bg="light" style={{ marginTop: "50px" }}>
                      <Goals
                        goalData={goalData}
                        groupID={groupID}
                        errorChecking={props.errorCheck}
                        timer={props.timerCheck}
                        triggerTimer={triggerTimer}
                        setTime={setTime}
                        time={time}
                        openGameStartModal={setOpenGameStartModal}
                        timesPlayed={setTimesPlayed}
                        resetGame={resetGame}
                        onResetGame={setResetGame}
                        wordData={wordData}
                      />
                    </Card>
                  </DndProvider>))
      setDNDEngineReady(true)
     }else{
      setDNDEngine((<DndProvider backend={HTML5Backend}>
                    <Card bg="light" style={{ marginTop: "50px" }}>
                      <Goals
                        goalData={goalData}
                        groupID={groupID}
                        errorChecking={props.errorCheck}
                        timer={props.timerCheck}
                        triggerTimer={triggerTimer}
                        setTime={setTime}
                        time={time}
                        openGameStartModal={setOpenGameStartModal}
                        timesPlayed={setTimesPlayed}
                        resetGame={resetGame}
                        onResetGame={setResetGame}
                        wordData={wordData}
                      />
                    </Card>
                  </DndProvider>))
      setDNDEngineReady(true)
     };
     setDNDEngineReady(false)
  }

  const handleResetGame = () => {
    setTimesPlayed(0)
    setSelectedGame()
    setOpenGameStartModal(true)
    setGoalData([])
    setResetGame(1)
  };
  
  useEffect(() => {
    if (resetGame === 1) {
      handleResetGame();
    }
  }, [resetGame]);

  return (
    <>
    {!dndEngineReady ? <>
                    <BackToGameList />
                    <div
                      className="main-content"
                      style={{ margin: "20px", background: "rgb(240, 244, 249)" }}
                    >
                      <GameStart
                        check={props.errorCheck}
                        timer={props.timerCheck}
                        onStartTime={setTriggerTimer}
                        setTime={setTime}
                        openGameStartModal={openGameStartModal}
                        timesPlayed={timesPlayed}
                        setResetGame={setResetGame}
                        onGameStartModal={setOpenGameStartModal}
                        gameSelect={gameSelect}
                        setSelectedGame={setSelectedGame}
                        gameTitle={"Category Sorts"}
                        gameDescription={`To play, touch the "Start Game" button. 
                      Then touch and drag words into their respective categories.
                      Thank you for playing, and enjoy!`}
                      />
                      {dndEngine}
                    </div>
                    </> : <>Loading...</>}
                  </>
    )
    }

export default CategorySorts;
